<template>
  <a
    class="upgrade_button"
    href="https://outlook.office365.com/owa/calendar/innopearl@innopearl.ch/bookings/"
    target="_blank"
    rel="noopener noreferrer"
  >
    Upgrade
  </a>
</template>

<script>
export default {
  name: 'UpgradeButton'
}
</script>

<style scoped>
.upgrade_button{
  background: #b38d2f;
  border: 1px solid #b38d2f;
  color: #fff;
  padding: 10px 30px;
  font-weight: 600;
  border-radius: 200px;
  text-transform: uppercase;
  font-size: 15px;
  display: inline-block;
  text-decoration: none;
}

.innopearl_topbar_content .upgrade_button {
  align-self: center;
  
}
</style>
